import { styled, alpha } from '@mui/material/styles';
import { Box, FormControl, Select, IconButton, Typography } from '@mui/material';
import { colors, spacing } from '../../../styles/theme/index';

// 🎨 PROPUESTA 5: Minimalista Premium con Degradado Verde
// Diseño elegante, moderno y minimalista que usa el degradado verde del sistema

export const PaginationContainer = styled(Box)(({ theme }) => ({
  padding: '2px 10px',
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.xs,
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

export const PaginationInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.xs,
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.lg,
  },
}));

export const PaginationText = styled(Typography)(({ theme }) => ({
  fontSize: '0.8125rem', // 13px
  color: theme.palette.text.secondary,
  fontWeight: 400,
  letterSpacing: '0.01em',
}));

export const PaginationControls = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: spacing.sm,
}));

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  minWidth: 88,
  '& .MuiOutlinedInput-root': {
    borderRadius: '7px',
    fontSize: '0.8125rem',
    border: `1px solid ${theme.palette.divider}`,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      borderColor: alpha(colors.success.main, 0.5),
    },
    '&.Mui-focused': {
      borderColor: colors.success.main,
      borderWidth: '2px',
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: colors.success.main,
      },
    },
  },
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  fontSize: '0.8125rem',
  '& .MuiSelect-select': {
    padding: '6px 28px 6px 10px',
  },
}));

export const PageButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.secondary,
  padding: '6px 10px',
  borderRadius: '7px',
  fontSize: '0.8125rem',
  minWidth: '36px',
  height: '34px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: 'transparent',
  transition: 'all 0.2s ease-in-out',
  '&:focus-visible': {
    outline: `2px solid ${alpha(colors.success.main, 0.35)}`,
    outlineOffset: 2,
  },
  '&:hover:not(:disabled)': {
    background: 'linear-gradient(to right, rgba(6, 182, 212, 0.1), rgba(16, 185, 129, 0.1))',
    borderColor: alpha(colors.success.main, 0.3),
    color: colors.success.main,
    transform: 'translateY(-1px)',
  },
  '&:disabled': {
    color: theme.palette.text.disabled,
    borderColor: theme.palette.divider,
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.action.disabledBackground : colors.grey[100],
    opacity: 1,
    cursor: 'not-allowed',
    '& svg': {
      opacity: 0.7,
    },
  },
  // Página activa con degradado verde (igual que las pestañas)
  '&.active': {
    background: 'linear-gradient(to right, rgb(6, 182, 212), rgb(16, 185, 129))',
    color: 'white',
    borderColor: 'transparent',
    boxShadow: '0 2px 8px rgba(6, 182, 212, 0.3)',
    fontWeight: 500,
    '&:hover': {
      background: 'linear-gradient(to right, rgb(8, 145, 178), rgb(5, 150, 105))',
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(6, 182, 212, 0.4)',
    },
  },
}));

export const EllipsisButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.disabled,
  cursor: 'default',
  padding: '6px 4px',
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));
